import { useState, useEffect } from "react";
import Modal from "../../../components/Modal";
import InputForm from "../../../components/InputForm";
import { convertToRupiah } from "../../../helper/RupiahDashboard";
import "react-toastify/dist/ReactToastify.css";

const Deposit = ({ data, activeModal, closeModal, onSubmit }) => {
  const modalClass = activeModal ? "effect-scale show" : "";
  const modalStyle = activeModal ? { display: "block", paddingRight: "17px" } : {};

  const [note, setNote] = useState(null);
  const [type, setType] = useState(null);
  const [amount, setAmount] = useState(0);
  const [depositBalance, setDepositBalance] = useState(data?.amount || 0);
  const [validate, setValidate] = useState(false);
  const [optionType, setOptionType] = useState([]);

  const handleChangeAmount = (value) => {
    let numericValue = value.replace(/\D/g, "");
    if (numericValue.length > 1 && numericValue.startsWith("0")) {
      numericValue = numericValue.replace(/^0+/, "");
    }
    if (numericValue.length > 6) {
      numericValue = "999999";
    }
    if (numericValue === "") {
      numericValue = "0";
    }

    setAmount(numericValue);
  };

  const handleSubmit = () => {
    const payload = {
      reference_type: type === "Saldo Awal" ? "initial_balance" : type === "Top Up" ? "topup_balance" : "withdrawal",
      amount: Number(amount),
      notes: note === "" ? null : note,
    }

    onSubmit(data?.user_id, payload);
  }

  useEffect(() => {
    const opt = [];

    if (data?.can_setup_balance > 0) opt.push("Saldo Awal") 
    opt.push("Top Up");
    if (data?.amount > 0) opt.push("Penarikan")
    
    setOptionType(opt);
  }, [data?.amount]);

  useEffect(() => {
    let deposit = data?.amount || 0;
    if (type === "Top Up" || type === "Saldo Awal") deposit += Number(amount);
    else if (type === "Penarikan") deposit -= Number(amount);

    setDepositBalance(deposit);
    setValidate(amount >= 1000 && deposit >= 0 && type)
  }, [amount, type, data?.amount]);

  const forms = [
    {
      margin: "mb-3",
      label: "Jenis Transaksi",
      type: "select",
      id: "type",
      defaultOption: "default",
      placeholder: "Pilih Jenis Transaksi",
      option: optionType,
      value: type,
      changeHandler: setType,
    },
    {
      margin: "mb-3",
      label: "Amount",
      type: "text",
      id: "amount",
      value: convertToRupiah(amount || 0),
      changeHandler: handleChangeAmount,
    },
    {
      margin: "mb-3",
      label: "Total Deposit",
      type: "text",
      id: "deposit_balance",
      disabled: true,
      value: convertToRupiah(depositBalance || 0),
    },
    {
      margin: "mb-3",
      label: "Note",
      type: "text",
      id: "note",
      value: note,
      changeHandler: setNote,
    },
  ];

  return (
    <Modal
      activeModal={modalClass}
      activeStyle={modalStyle}
      title={`Deposit | ${data?.name || "N/A"} - ${data?.user_id || "N/A"}`}
      closeClick={closeModal}
      submitHandler={handleSubmit}
      type="Simpan"
      buttonDisable={!validate}
      modalType="modal-md"
    >
      <div className="alert alert-warning d-flex align-items-center gap-3" role="alert">
        <i className="fa fa-exclamation-triangle" style={{ fontSize: "1.5rem" }}></i>
        <div className="text-justify mb-0">
          <strong>Perhatian!</strong> Pastikan data yang Anda masukkan benar. Data yang telah disimpan tidak dapat diubah kembali.
        </div>
      </div>

      {forms.map((form) => (
        <InputForm key={form.id} {...form} />
      ))}
    </Modal>
  );
};

export default Deposit;
